import { useEffect, useState } from 'react'

import './styles.scss'

function Component({ articleId }) {
    const urlParams = new URLSearchParams(window.location.search)

    const [article, setArticle] = useState(null)

    useEffect(() => {
        getData()
    }, [])

    async function getData() {
        try {
            const response = await fetch(`https://rsa-marketing.fly.dev/api/v2/news/${urlParams.get('id' || '')}`)
            let data = await response.json()
            
            if (data) {    
                setArticle(data)
            }
        } catch (error) {
            console.log('error', error)
        }
    }

    return (
        <>
            <div className="details">
                <div className="container">
                    <div className="header grid">
                        <div className="imageWrapper">
                            <div className="image" style={{backgroundImage: `url(${article?.mainImage.normal})`}}></div>
                        </div>

                        {/* <p className='titlePrefix'>
                            {article?.type}
                        </p> */}

                        <h1 className='title'>
                            {article?.title}
                        </h1>
                        <p className='intro'>
                            {article?.leadText}
                        </p>
                        <p className='published'>
                            {new Date(article?.published).toLocaleString()}
                        </p>
                    </div>
                    <div className="content grid">
                        <div className="articleText">
                            <div dangerouslySetInnerHTML={{ __html: article?.body }} />
                        </div>
                        <div className="sidebar">
                            <div className="images">
                                <div className='sidebarTitle'>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="m2.25 15.75 5.159-5.159a2.25 2.25 0 0 1 3.182 0l5.159 5.159m-1.5-1.5 1.409-1.409a2.25 2.25 0 0 1 3.182 0l2.909 2.909m-18 3.75h16.5a1.5 1.5 0 0 0 1.5-1.5V6a1.5 1.5 0 0 0-1.5-1.5H3.75A1.5 1.5 0 0 0 2.25 6v12a1.5 1.5 0 0 0 1.5 1.5Zm10.5-11.25h.008v.008h-.008V8.25Zm.375 0a.375.375 0 1 1-.75 0 .375.375 0 0 1 .75 0Z" />
                                    </svg>
                                </div>
                                <div className="imageItemWrapper grid">
                                    {
                                        article?.images?.map((item, index) => {
                                            return (
                                                <a href={item.url} target="_blank" key={index} className="imageWrapper">
                                                    <img src={item.normal} alt="" />
                                                </a>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                            <div className="files">
                                <div className='sidebarTitle'>
                                    <svg xmlns="http://www.w3.org/2000/svg" fill="none" viewBox="0 0 24 24" strokeWidth="1.5" stroke="currentColor">
                                        <path strokeLinecap="round" strokeLinejoin="round" d="m18.375 12.739-7.693 7.693a4.5 4.5 0 0 1-6.364-6.364l10.94-10.94A3 3 0 1 1 19.5 7.372L8.552 18.32m.009-.01-.01.01m5.699-9.941-7.81 7.81a1.5 1.5 0 0 0 2.112 2.13" />
                                    </svg>
                                </div>
                                <div className="filesWrapper">
                                    {
                                        article?.logos?.map((item, index) => {
                                            return (
                                                <a href={item.url} target="_blank" key={index} className="fileWrapper">
                                                    {/* <div className="file" style={{backgroundImage: `url(${article?.logos.normal})`}}></div> */}
                                                    <img src={item.normal} alt="" />
                                                </a>
                                            )
                                        })
                                    }
                                </div>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
        </>
    )
}

export default Component